"use strict";

exports.__esModule = true;
exports.Dataset = void 0;
const Dataset = exports.Dataset = {
  make: ({
    id = '',
    collectionId = '',
    mode = 'read-write',
    pagination = Dataset.makePagination(),
    currentRecordIndex = 0,
    filter = null,
    sort = null
  } = {}) => ({
    id,
    collectionId,
    mode,
    pagination,
    currentRecordIndex,
    filter,
    sort
  }),
  makePagination: ({
    type = 'offset',
    offset = 0,
    pageSize = 1,
    total = 0
  } = {}) => ({
    type,
    offset,
    pageSize,
    total
  }),
  getReadOptions: ({
    collectionId,
    filter,
    sort
  }) => ({
    collectionId,
    filter,
    sort
  }),
  getTotalCount: dataset => dataset.pagination.total,
  getCurrentRecordIndex: dataset => dataset.currentRecordIndex,
  isReadonly: dataset => dataset.mode === 'read',
  hasNextRecord: ({
    pagination: {
      total
    },
    currentRecordIndex
  }) => currentRecordIndex + 1 < total,
  hasPrevRecord: ({
    currentRecordIndex
  }) => currentRecordIndex > 0,
  hasNextPage: ({
    currentRecordIndex,
    pagination: {
      total,
      pageSize
    }
  }) => {
    const totalPages = Math.ceil(total / pageSize);
    const nextPageIndex = Math.floor(currentRecordIndex / pageSize) + 1;
    return nextPageIndex < totalPages;
  },
  hasPrevPage: ({
    currentRecordIndex,
    pagination: {
      pageSize
    }
  }) => {
    const prevPageIndex = Math.floor(currentRecordIndex / pageSize) - 1;
    return prevPageIndex >= 0;
  },
  // TODO: move to dataStore
  updateListing: (dataset, {
    records
  }) => ({
    ...dataset,
    records
  }),
  // TODO: move to dataStore
  updateCurrentRecord: (dataset, data) => ({
    ...dataset,
    records: [data]
  })
};
//# sourceMappingURL=dataset.js.map